<template>

    <div v-if="show" class="form_btn_container" id="form_btn_container">
        <!--  style="display: flex; justify-content: space-between; align-items: center;" -->
        <div class="flex justify-between items-center">
            <h3 style="color: var(--titulo)">{{ form_title }}:</h3>
            <div class="flex items-center gap-2">
                <HistoricoObjetoButton
                    model-name="Familia"
                    :objeto-id="form_data.id"
                    modelo-label="Família"
                    variant="bare"
                    icon-only
                />
                <AppButton v-bind:visibility="true" left_icon="fa-regular fa-circle-xmark fa-xl" style="color: var(--icon);" emitType="close"
                    @close="close" :width=20 :height=20 />
            </div>
        </div>
        <div class="form_container">
            <div id="left_form" class="left_form">
                <div class="input_container">
                    <label for="codigo" class="input_label text-[var(--text)]">Nome:</label>
                    <input 
                    style="color: var(--text);"
                    type="text" v-model="formData.nome" placeholder="Nome" class="input_field"
                        :class="{ 'input-required': !formData.nome }" :disabled="formData.status==='desativado'">
                </div>
                <div class="flex">
                    <label style="min-width: 7rem;">Descriçao:</label>
                    <textarea
                    v-model="formData.descricao" placeholder="Descrição" class="input_field textarea"
                        :class="{ 'input-required': !formData.descricao }" :disabled="formData.status==='desativado'" style="resize: none; color: var(--text);"></textarea>
                </div>
            </div>
            <div  v-if="showRight"  class="right_form">
                <div class="img_container">
                    <div class="img_btn_container">
                        <div class="img_container">
                            <img id="familia_img" :src="formData.foto" alt="familia">
                        </div>
                        
                        <div style="margin-top: 0.5rem;">
                            <label for="input-file">
                                <i class="fa-solid fa-circle-plus fa-xl" style="color: var(--icon); cursor: pointer;"></i>
                            </label>
                            <input type="file" accept="image/*" id="input-file" @change="upload_img" hidden :disabled="formData.status==='desativado'">
                        </div>

                    </div>

                </div>
                <div style="display: flex; gap: 0.5rem; padding: 0rem; align-self: flex-start;">
                    <AppButton v-if="this.validPermission('P0009')" v-bind:visibility="!create_btn" :font_size="11" 
                        left_icon="fa-solid fa-pen-to-square" text="Produto" emitType="select"
                        @select="selectTable('produto')" :disabled="formData.status == 'desativado'" :color="formData.status == 'desativado' ? '#7B7B99' : 'rgb(93, 93, 152)'"/>
                    <AppButton v-if="this.validPermission('P0010')" v-bind:visibility="true" :font_size="11" 
                        left_icon="fa-solid fa-pen-to-square" text="Propriedades" emitType="select"
                        @select="selectTable('propriedades')" :disabled="formData.status == 'desativado'" :color="formData.status == 'desativado' ? '#7B7B99' : 'rgb(151, 151, 239)'"/>
                    <AppButton v-if="!create_btn && this.validPermission('P0011')" v-bind:visibility="true" :font_size="11" 
                        left_icon="fa-solid fa-pen-to-square" text="Critérios Rejeição" emitType="select"
                        @select="selectTable('tpRejeicao')" :disabled="formData.status == 'desativado'" :color="formData.status == 'desativado' ? '#7B7B99' : 'rgb(151, 151, 239)'" />
                </div>
            </div>
        </div>
        <div style="display: flex; gap: 0.5rem; padding: 1rem;">
            <button v-if="podeGerir && create_btn && validPermission('P0003')" class="btn" @click="showConfirm($event, 'create')">Criar</button>
            <button v-if="podeGerir && !create_btn && this.validPermission('P0012')" class="btn" @click="showConfirm($event, 'update')" :disabled="formData.status == 'desativado'" >Atualizar</button>
            <button v-if="podeGerir && !create_btn && this.validPermission('P0013')" class="px-2 py-2 rounded-xl bg-[#ff0000] text-white text-sm" @click="showConfirm($event, 'delete')">{{formData.status==='ativo'? 'Desativar':'Ativar'}}</button>
            <Button @click="openPopup($event)" label="Confirm" id="confirmButton" :aria-expanded="isVisible" :aria-controls="isVisible ? 'confirm' : null" /> 
           <ConfirmPopUp ref="myConfirm" @accept="onAccept" /> 
        </div>
    </div>
</template>

<script>

import AppButton from '@/components/updated/button.vue';
import { reactive } from 'vue';
import { ref } from 'vue';
import ConfirmPopUp from '@/components/modals/MyConfirmPopUp.vue';
import permissionMixin from '@/permissionMixin.js'
import HistoricoObjetoButton from '@/components/historico/HistoricoObjetoButton.vue';





export default {
    mixins: [permissionMixin],
    name: 'AppUserForm',
    components: {
        AppButton,
        ConfirmPopUp,
        HistoricoObjetoButton,
    },
    props: {
        podeGerir: {
            type: Boolean,
            default: () => true,
        },
        form_data: {
            type: Object,
            default: () => ({}),
        },
        set_data: {
            type: Object,
            default: () => ({}),
        },
        show: {
            type: Boolean,
            default: () => false,
        },
        form_title: {
            type: String,
            default: () => "No Title"

        },
        create_btn: {
            type: Boolean,
            default: () => false
        },
        update_visibility: {
            type: Boolean,
            default: () => false
        },
        disable_visibility: {
            type: Boolean,
            default: () => false
        },
        showRight: {
            type: Boolean,
            default: () => true
        }

    },

    data() {
        return {
            formData: {},
            emit_type: '',
        };
    },
    created() {
        this.updateFormData();
    },
  
    methods: {
        
        showConfirm(event, message) {
            this.emit_type=message;
            this.$refs.myConfirm.show(event.target);

        },
        onAccept() {
            if(this.emit_type=='create'){
                this.create();
            }
            else if(this.emit_type=='update'){
                this.update();
            }
            else if(this.emit_type=='delete'){
                this.disable();
            }
            else{
                this.$emit('show_table', this.emit_type);
            }

        },
 
        selectTable(name) {
            // Logic to handle selecting armazem
            this.$emit('show_table', name);
            
        },

        upload_img(event) {
            console.log("inside upload method")
            const file = event.target.files[0];
            if (file) {

                const reader = new FileReader();
                reader.onload = (e) => {
                    const img = document.getElementById('familia_img');
                    img.src = e.target.result;
                    // this.formData.foto = e.target.result;
                };
                reader.readAsDataURL(file);
                const formData = new FormData();
                formData.append('foto', file);
                this.formData.newFoto = formData;
            }
        },

        create() {
            if (!this.isValidForm()) return
            console.log("valid form")
            const formData = this.getFormData();
            //console.log("create formdata:", formData)
            this.$emit('create', formData);

        },
        update() {
            if (!this.isValidForm()) return
            const formData = this.getFormData();
            console.log("update formdata:", formData)
            this.$emit('update', formData);

        },

       
        disable() {
            //if(!this.isValidForm()) return
            const formData = this.getFormData();
            formData.object = 'familia';
            this.$emit('delete', formData);

            

        },
        isValidForm() {
            if (!this.formData.nome || !this.formData.descricao 
              ) {
                return false;
            }
            return true;
        },

    //     async create(data, url) {
    //       try {
    //           const res = await axios.post(url, data);
    //           return res.data.data;
    //       } catch (error) {
    //           console.error('Error getting data:', error);
    //       }
    //   },
       

        getFormData() {

            const formDataObject = {
                ...this.formData,
            };


            return formDataObject;
        },
        close() {
            this.$emit('close');
        },
        updateFormData() {

            this.formData = { ...this.form_data };
            console.log("form data:", this.formData)
        },
        isEmptyField(field) {

            if (["nome", "descricao"].includes(field)) {

                return ((this.formData[field] === '') || Array.isArray(this.formData[field]));
            }

            return false;
        },


    },

    watch: {
        form_data: {
            handler() {

                this.updateFormData();
                //this.isEmptyContactField()
            },
            immediate: true,
            deep: true,
        },
        showRight: {
            handler() {
                console.log("showRight:", this.showRight)
            },
            immediate: true,
            deep: true,
        }
    },


}
</script>



<style scoped>
@import 'primevue/resources/themes/aura-light-green/theme.css';
@import 'primevue/resources/themes/saga-blue/theme.css';
@import 'primevue/resources/primevue.min.css'; 
@import 'primeicons/primeicons.css'; 
.form_btn_container {

    display: flex;
    flex-direction: column;
    border-radius: 10px;
    background-color: var(--fundoForm);
    padding: 1rem;
}

.form_container {
    display: flex;
    gap: 2rem;
    padding: 1rem;
    border-radius: 10px;
}


.left_form {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

h3 {
    display: flex;
    padding: 0.4rem;
    color: white;
}

label {
    display: block;
    color: var(--label);
    font-size: 14px;
    padding: 0.2rem;
    min-width: 1rem;
    text-wrap: nowrap;
}


input[type="text"],
input[type="password"],
select {
    padding: 0.3rem;
    font-size: 10px;
    border-radius: 5px;
    border: 1px solid #cccccc;

}

.input_field.textarea {
    width: 200px;
    height: 100px;
}

.btn_div {
    color: white;
    display: flex;
    padding-left: 1rem;
    align-items: center;
    gap: 0.6rem;
}

.btn {
    width: fit-content;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    background-color: rgb(0, 102, 152);
    color: white;
    border: none;
    border-radius: 10px;
    padding: 0.5rem 0.8rem;
    cursor: pointer;
    gap: 0.5rem;
}

.data_set_class {
    margin-top: 1rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding: 1rem;
    border-radius: 10px;
    background-color: rgba(93, 93, 152, 0.55);
}

.data_set {

    font-size: 14px;
    color: white;
    display: flex;
    gap: 0.3rem;
}

.right_form {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 0.5rem;
    align-items: center;

}

.img_container {
    margin-top: -0.5rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    justify-content: center;
    align-items: center;
}

.img_btn_container {
    display: flex;
    gap: 0.5rem;
}

.img_container {
    display: flex;
    width: 150px;
    aspect-ratio: 1/1;
    height: auto;

}

.img_container img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
}


.signature_container {
    display: flex;
    gap: 1rem;
}

.tpa_certificado_container {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.signature_div {
    display: flex;
    gap: 1rem;
}

.signature_field_container {
    display: flex;
    width: 100px;
    height: auto;
    background-color: #626288;
    border-radius: 0.2rem;
}

.signature_field_container img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 0.2rem;
}

.signature_icon_container {
    display: flex;
    justify-content: center;
    padding-top: 1rem;

}

.right_input_container {

    margin-top: 0.5rem;
    align-self: flex-start;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    border-radius: 0.5rem;


}



.input_container {
    display: flex;
    align-items: center;
    gap: 1rem;
}

.input_label {
    width: 100px;
    color: white;
    font-size: 14px;
}

.input_field {
    flex: 1;
    padding: 0.3rem;
    font-size: 10px;
    border-radius: 5px;
    border: 1px solid #ccc;
}

.rae_container {
    margin-top: 1rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    border-radius: 10px;
    padding: 1rem;
    background-color: rgba(93, 93, 152, 0.55);
}

.text-white {
    color: var(--label);
}
</style>
